<template>
  <div class="page-module">
    <mt-popup
      v-model="$store.state.numericalSwitch"
      position="bottom"
      class="bottom-select-popup"
    >
      <div class="inner" @click.stop="">
        <div class="popup-head">
          数值设定
          <span class="howto" @click="openHowto"></span>
        </div>
        <ul class="popup-body">
          <li class="item clearfix" @click="selectNumerical()">
            <span class="cell-title">数值项</span>
            <div class="cell-value jump-ico elli" v-text="numOptionVal"></div>
          </li>
          <li class="item clearfix" @click="selectMode()">
            <span class="cell-title">赋值方式</span>
            <div class="cell-value jump-ico elli" v-text="numModeVal"></div>
          </li>
          <li class="item clearfix" @click="setNum()">
            <span class="cell-title">数值</span>
            <div class="cell-value jump-ico elli" v-text="numValue"></div>
          </li>
        </ul>
        <div v-if="showNoticeCell()" class="notice elli">
          剧情至此处，<i class="flag">{{numOptionVal}}</i> {{getMode(numModeVal)}} <i class="flag">{{numValue}}</i>
        </div>
        <div class="popup-btns">
          <button class="btn" @click="$store.state.numericalSwitch = false">取消</button>
          <button class="btn confirm" @click="submitNumber()">确定</button>
        </div>
      </div>
    </mt-popup>
    <rule-popup v-if="rulePopupSwitch" v-bind="rulePopupConf"></rule-popup>
    <radio-popup v-if="radioPopupSwitch" v-bind="radioPopupConf" @close="radioPopupSwitch = false"></radio-popup>
    <prompt-popup v-if="promptPopupSwitch" v-bind="promptPopupConf"></prompt-popup>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import {Methods} from '../const/common';
  import {GameData} from '../store/GameData';
  import RulePopup from '../components/rule_popup';
  import RadioPopup from '../components/radio_popup';
  import promptPopup from '../components/prompt_popup';

  export default {
    name: "numerical_setup",
    components: {
      'rule-popup': RulePopup,
      'radio-popup': RadioPopup,
      'prompt-popup': promptPopup
    },
    props: {
      _switch: Boolean
    },
    computed: {
      numericalSwitch() {
        return store.state.numericalSwitch;
      }
    },
    data() {
      return {
        radioChangeIndex: null,
        // radioItemChange: false,
        popupSwitch: store.state.numericalSwitch,
        rulePopupConf: {},
        rulePopupSwitch: false,
        radioPopupConf: {},
        radioPopupSwitch: false,
        numOptions: [],
        numModeOptions: [{tname: '=（等于）', flag: true}, {tname: '+（增加）'}, {tname: '-（减少）'}],
        promptPopupSwitch: false,
        promptPopupConf: {},
        numOptionVal: '请选择',
        numModeVal: '=（等于）',
        // newAddNum: [],
        setNumIndexSign: 0,
        numMode: 0,
        numValue: 0,
      }
    },
    watch: {
      numericalSwitch(newVal) {
        if (!newVal) {
          this.$emit('close')
        } else {
          this.init();

          if (store.state.numericalType === 'edit') {
            let _data = store.state.numericalEditData;

            this.numOptionVal = this.numOptions[_data.param[0]].numName;
            this.numModeVal = (() => {
              switch (_data.param[1]) {
                case 0:
                  return '=（等于）';
                case 1:
                  return '+（增加）';
                case 2:
                  return '-（减少）';
              }
            })();

            this.numMode = _data.param[1];
            this.numValue = _data.param[2];

            this.numOptions.forEach((item, i) => {
              if (item.numName === this.numOptionVal) {
                Vue.set(item, 'flag', true);
                this.setNumIndexSign = i;
              } else {
                Vue.set(item, 'flag', false);
              }
            });
          }
        }
      },
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.getAllNumber();

        let lastSetNumIndex = Middle.ProjectData.lastSetNumber.index,
          lastSetNumName = Middle.ProjectData.lastSetNumber.numName;
        let _this = this;

        if (lastSetNumIndex > -1 && lastSetNumName !== '') {
          this.numOptions.forEach(function (_item, i) {
            if (_item.index === lastSetNumIndex) {
              Vue.set(_item, 'flag', true);
              _this.numOptionVal = _item.numName;
              _this.setNumIndexSign = i;
            }
          });
        }
      },
      initNumVal() {
        this.numMode = 0;
        this.numValue = 0;
        this.numModeVal = '=（等于）';
        this.numModeOptions.forEach(function (_item) {
          Vue.set(_item, 'flag', false);
        });
        Vue.set(this.numModeOptions[0], 'flag', true);
      },
      getAllNumber() {
        this.numOptions = [].concat(JSON.parse(JSON.stringify(Middle.MiddleData.getAllNumber())));
        this.radioPopupConf.options = this.numOptions;
      },
      submitNumber() {
        if (this.numOptions.length <= 0 && !this.numOptions[this.setNumIndexSign]) {
          return Toast({
            message: '请选择数值项'
          });
        }

        let _conf = this.numOptions[this.setNumIndexSign];

        if (store.state.numericalType === 'add') {
          GameData.AddEvent("op_number", [_conf.index, this.numMode, this.numValue]);
        } else {
          GameData.AddEvent("event_change_number_value", [_conf.index, this.numMode, this.numValue], store.state.numericalEditData.eventIndex);
        }
        this.initNumVal();
        this.$emit('close');
      },
      showNoticeCell() {
        let _res = false;

        if (this.numOptionVal !== '请选择') {
          _res = true;
        }
        return _res;
      },
      getMode(mode) {
        return mode.substring(0, 1);
      },
      openHowto() {
        this.rulePopupConf = {
          title: '什么是数值设定？',
          desc: [
            '1、对话项、旁白项都可以设置数值',
            '2、数值设定主要是为了制作剧情的分支判断，以及角色的状态变化，设置了数值后，还需要配合条件设定进行使用；',
            '3、在一个对话、旁白上，最多只能设置5个数值变化；',
            '4、举例，若一个对话设置了[005]女主角好感加1，即意味着这个对话后会使女主角的好感增加1点。'
          ],
          cancelCallBack: () => {
            this.rulePopupSwitch = false;
          }
        };
        this.rulePopupSwitch = true;
      },
      setNum() {
        this.promptPopupConf = {
          titleText: '输入想要设置的数值',
          val: this.numValue,
          reg: /\D/g,
          regStr: '',
          maxLength: 0,
          placeholder: '请输入数值',
          inputType: 'number',
          btnConf: [
            {
              text: '取消',
              callBack: () => {
                this.promptPopupSwitch = false;
              }
            },
            {
              text: '确定',
              callBack: res => {
                if (res === '') {
                  return Toast({
                    message: '请输入数值'
                  });
                }
                this.numValue = res;
                this.promptPopupSwitch = false;
              }
            }
          ],
        };
        this.promptPopupSwitch = true;
      },
      selectMode() {
        this.radioPopupConf = {
          title: '请选择赋值方式',
          options: this.numModeOptions,
          btnLock: false,
          addItemSwitch: false,
          radioSelect: (item, index) => {
            this.numModeOptions.forEach(function (_item) {
              Vue.set(_item, 'flag', false);
            });
            Vue.set(this.numModeOptions[index], 'flag', true);
            this.numModeVal = item.tname;
            if (item.tname.indexOf('-') > -1) {
              this.numMode = 2;
            } else if (item.tname.indexOf('+') > -1) {
              this.numMode = 1;
            }
            this.radioPopupSwitch = false;
          },
          cancel: () => {
            this.radioPopupSwitch = false;
          },
          confirm: res => {
          }
        };
        this.radioPopupSwitch = true;
      },
      selectNumerical() {
        let _this = this;

        this.radioPopupConf = {
          title: '选择一个数值',
          options: this.numOptions,
          editSwitch: true,
          addItemSwitch: true,
          valKey: 'showName',
          btnConf: [
            {
              text: '确定',
              callBack: () => {
                this.numOptions.forEach((_item, i) => {
                  if (_item.flag) {
                    this.numOptionVal = _item.numName;

                    if (this.numOptions[this.setNumIndexSign].numName !== _item.numName) {
                      this.setNumIndexSign = i;
                      this.initNumVal();
                    }
                  }
                });
                this.radioPopupSwitch = false;
              }
            }
          ],
          radioSelect: (item, index) => {
            this.numOptions.forEach(function (_item) {
              Vue.set(_item, 'flag', false);
            });
            Vue.set(this.numOptions[index], 'flag', true);
          },
          addItemCallBack: () => {
            this.promptPopupConf = {
              titleText: '添加数值项',
              val: '',
              maxLength: 15,
              placeholder: '请输入数值名称，不超过15个字',
              btnConf: [
                {
                  text: '取消',
                  callBack: () => {
                    this.promptPopupSwitch = false;
                    this.radioPopupSwitch = true;
                  }
                },
                {
                  text: '添加',
                  callBack: res => {
                    if (res === '') {
                      return Toast({
                        message: '请填写数值名称！'
                      });
                    }

                    let _flagItem = null, _lock = false;

                    this.numOptions.forEach(function (item) {
                      if (item.flag) {
                        _flagItem = item;
                      }
                      if (item.numName === res) {
                        _lock = true;
                        Toast({
                          message: '当前数值项名称已存在！'
                        });
                      }
                    });
                    if (_lock) {
                      return false;
                    }
                    Methods.addNumber(res);
                    this.getAllNumber();
                    if (_flagItem !== null) {
                      Vue.set(_flagItem, 'flag', false);
                    }
                    Vue.set(this.numOptions[this.numOptions.length - 1], 'flag', true);
                    this.radioPopupConf.options = this.numOptions;

                    this.promptPopupSwitch = false;
                    this.radioPopupSwitch = true;
                  }
                }
              ],
            };

            this.radioPopupSwitch = false;
            this.promptPopupSwitch = true;
          },
          edit: (itemIndex, numIndex) => {
            this.promptPopupConf = {
              titleText: '编辑数值项',
              val: this.numOptions[itemIndex].numName,
              maxLength: 15,
              btnConf: [
                {
                  text: '取消',
                  callBack: () => {
                    this.promptPopupSwitch = false;
                    this.radioPopupSwitch = true;
                  }
                },
                {
                  text: '保存',
                  callBack: res => {
                    if (res === '') {
                      return Toast({
                        message: '请填写数值名称！'
                      });
                    }
                    let _editLock = false;

                    for (let _i = 0; _i < _this.numOptions.length; _i++) {
                      if (_this.numOptions[_i].numName === res && _this.numOptions[_i].index !== numIndex) {
                        _editLock = true;
                        break;
                      }
                    }
                    if (_editLock) {
                      Toast({
                        message: '当前数值项名称已存在！'
                      });
                    } else {
                      Middle.MiddleData.setNumberData(itemIndex, res);
                      this.getAllNumber();
                      Vue.set(_this.numOptions[itemIndex], 'flag', true);
                      this.promptPopupSwitch = false;
                      this.radioPopupSwitch = true;
                    }
                  }
                }
              ],
            };

            this.radioPopupSwitch = false;
            this.promptPopupSwitch = true;
            // this.radioItemChange = true;
            this.radioChangeIndex = i;
          },
          remove: (i) => {
            if (Middle.MiddleData.numberUse()) {
              this.radioPopupSwitch = false;
              Methods.messageConfirm('', '当前数值已经被引用了100次，是否确认删除？', '删除', '再看看', () => {
                if (this.numOptions[i].flag) {
                  Vue.set(this.numOptions[0], 'flag', true);
                }
                // this.numOptions.splice(i, 1);
                Middle.MiddleData.deleteNumberData(i);
                this.getAllNumber();
                this.radioPopupSwitch = true;
                Toast({
                  message: '数值项已删除'
                })
              }, () => {
                this.radioPopupSwitch = true;
              })
            } else {
              Toast({
                message: '测试：已经使用，不能删除'
              });
            }
          }
        };
        this.radioPopupSwitch = true;
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/bottom_select_popup.css";
</style>



// WEBPACK FOOTER //
// src/components/numerical_setup.vue